import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

interface UseDeleteAlbumArgs {
  eventVaultId: number
  albumId: number

}

export async function deleteAlbum(eventVaultId: number, id: number) {
  await axios.delete(`api/event/${eventVaultId}/album/${id}`)
}

export function useDeleteAlbum() {
  return useMutation({
    mutationFn: ({ eventVaultId, albumId }: UseDeleteAlbumArgs) => deleteAlbum(eventVaultId, albumId),
  })
}
